import React, { useState, useEffect } from 'react';
import { Box, Typography, Avatar, Container } from '@mui/material';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { Autoplay } from 'swiper/modules';
import { getTestimonials } from '../../services/Apis'; 

const Testimonials = () => {
    const [swiperInstance, setSwiperInstance] = useState(null);
    const [activeIndex, setActiveIndex] = useState(0);
    const [testimonials, setTestimonials] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchTestimonials = async () => {
            const res = await getTestimonials();
            let arr = [];
            if (Array.isArray(res)) arr = res;
            else if (Array.isArray(res?.testimonials)) arr = res.testimonials;
            else if (Array.isArray(res?.getAllTestimonials)) arr = res.getAllTestimonials; 
            setTestimonials(arr);
            setLoading(false);
        };
        setLoading(true);
            fetchTestimonials();
    }, []);

    return (
        <Container maxWidth="xl" width={"80%"} sx={{ pr: "0px !important", pl: "10px !important" }}>
            <Box sx={{ p: 2 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    <Typography
                        variant="h3"
                        sx={{
                            fontWeight: 600,
                            fontFamily: "Poppins",
                            color: "#CB4422",
                            borderLeft: "4px solid #000000",
                            paddingLeft: 1,
                        }}
                    >
                        Testimonials
                    </Typography>
                </Box>

                {loading ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 220 }}>
                        <Box sx={{ display: 'flex', gap: 1 }}>
                            <span className="red-dot" />
                            <span className="red-dot" style={{ animationDelay: '0.2s' }} />
                            <span className="red-dot" style={{ animationDelay: '0.4s' }} />
                        </Box>
                        <style>
                            {`
                            .red-dot {
                                display: inline-block;
                                width: 14px;
                                height: 14px;
                                border-radius: 50%;
                                background: #CB4422;
                                margin: 0 4px;
                                animation: bounce 1s infinite;
                            }
                            @keyframes bounce {
                                0%, 80%, 100% { transform: scale(1); opacity: 1; }
                                40% { transform: scale(1.4); opacity: 0.7; }
                            }
                            `}
                        </style>
                    </Box>
                ) : (
                    <>
                        <Swiper
                            modules={[Autoplay]}
                            spaceBetween={30}
                            onSwiper={(swiper) => setSwiperInstance(swiper)}
                            onSlideChange={(swiper) => setActiveIndex(Math.floor(swiper.activeIndex / 2))}
                            autoplay={{ delay: 3000, disableOnInteraction: false }}
                            slidesPerView={2}
                            breakpoints={{
                                0: { slidesPerView: 1 },      // 1 slide on mobile
                                600: { slidesPerView: 1 },    // 1 slide on small tablets
                                900: { slidesPerView: 2 },    // 2 slides on desktop
                            }}
                            style={{ paddingBottom: '25px' }}
                        >
                            {testimonials.map((testimonial, index) => (
                                <SwiperSlide key={index}>
                                    <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2, backgroundColor: '#fff8ee', p: 4, borderRadius: 2 }}>
                                        <Avatar src={testimonial.image || testimonial.imageUrl} alt={testimonial.name} sx={{ width: 100, height: 100 }} />
                                        <Box>
                                            <Typography
                                                variant="body1"
                                                sx={{
                                                    mb: 2,
                                                    overflow: 'hidden',
                                                    display: '-webkit-box',
                                                    WebkitLineClamp: { xs: 3, md: 5 }, // 3 lines on mobile, 5 on desktop
                                                    WebkitBoxOrient: 'vertical',
                                                    textOverflow: 'ellipsis',
                                                    minHeight: { xs: 72, md: 120 }, // reserve space for 3/5 lines
                                                }}
                                            >
                                                “{testimonial.description}”
                                            </Typography>
                                            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '5px' }}>
                                                <Typography variant="subtitle1" sx={{ color: '#d9534f' }}>{testimonial.name},</Typography>
                                                <Typography variant="body2" color="textSecondary" sx={{ mt: 0.5 }}>{testimonial.designation}</Typography>
                                            </Box>
                                        </Box>
                                    </Box>
                                </SwiperSlide>
                            ))}
                        </Swiper>

                        {/* Custom Pagination */}
                        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mb: 3 }}>
                            {Array.from({ length: Math.ceil(testimonials.length / 2) }).map((_, index) => (
                                <Box
                                    key={index}
                                    onClick={() => swiperInstance?.slideTo(index * 2)}
                                    sx={{
                                        width: 34,
                                        height: 3,
                                        bgcolor: index === activeIndex ? '#d9534f' : '#ccc',
                                        cursor: 'pointer',
                                        borderRadius: 2,
                                        transition: 'all 0.3s',
                                    }}
                                />
                            ))}
                        </Box>
                    </>
                )}
            </Box>
        </Container>
    );
};

export default Testimonials;